import AppleIcon from "components/svgs/AppleIcon";
import CloseIcon from "components/svgs/CloseIcon";
import FacebookWhiteIcon from "components/svgs/FacebookWhiteIcon";
import GoogleIcon from "components/svgs/GoogleIcon";
import React, { useState } from "react";
import Popup from "reactjs-popup";

const SignupPopup = ({
  showSignupPopup,
  setShowSignupPopup,
  setShowLoginPopup,
}) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleSignup = async () => {
    console.log("formData", formData);
  };

  const handleClosePopup = () => {
    setFormData({
      email: "",
      password: "",
      confirmPassword: "",
    });
    setShowSignupPopup(false);
  };
  return (
    <Popup
      open={showSignupPopup}
      onClose={handleClosePopup}
      closeOnDocumentClick={false}
      className="auth-popup"
    >
      <div className="close-auth-popup" onClick={handleClosePopup}>
        <CloseIcon />
      </div>
      <div className="auth-popup-container">
        <div className="app-logo-container">
          <div className="app-logo">PAAH</div>
        </div>
        <div className="auth-to">Sign up to Pan Armenian ArtHub</div>
        <div className="form-input">
          <div className="input-wrapper">
            <input
              type="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
          </div>
          <div className="input-wrapper">
            <input
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />
          </div>
          <div className="input-wrapper">
            <input
              type="password"
              placeholder="Repeat Password"
              value={formData.confirmPassword}
              onChange={(e) =>
                setFormData({ ...formData, confirmPassword: e.target.value })
              }
            />
          </div>
          <div className="auth-btn" onClick={handleSignup}>
            <button>Sign up</button>
          </div>
        </div>
        <div className="or">OR</div>
        <div className="alternative-auth">
          <div className="withProvider">
            <FacebookWhiteIcon />
            Sign Up with Facebook
          </div>
          <div className="withProvider">
            <GoogleIcon />
            Sign Up with Google
          </div>
          <div className="withProvider">
            <AppleIcon />
            Sign Up with Apple
          </div>
          <div className="no-account">
            Already have an account?{" "}
            <span
              onClick={() => {
                handleClosePopup();
                setTimeout(() => {
                  setShowLoginPopup(true);
                }, 100);
              }}
            >
              LOG IN
            </span>
          </div>
        </div>
        <div className="agreement">
          By clicking Sign Up or Continue with Email, Google, Apple or Facebook,
          you agree to PAAH's{" "}
          <a href="http://localhost:3000" target="_blank" rel="noreferrer">
            Terms and Conditions
          </a>{" "}
          and{" "}
          <a href="http://localhost:3000" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          .
        </div>
      </div>
    </Popup>
  );
};

export default SignupPopup;
